module.exports = __webpack_public_path__ + "img/TV.1703f290.jpg";